import { Link, useNavigate, useParams } from "react-router-dom";
import SideBarWrapper from "../../../components/common/SideBarWrapper";
import Navbar from "../../../layout/Navbar";
import { useEffect, useState } from "react";
import { baseURL } from "../../../utils/misc";
import useAuth from "../../../hooks/useAuth";
import PestForm from "../../../components/PestManagementRecords/PestForm";
import Footer from "../../../layout/Footer";
import { toast } from "react-toastify";

const EditPestRecord = () => {
    const { pestRecordId } = useParams();
    const [pestRecords, setPestRecords] = useState(null);
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }
        // Fetch workflow process data when the component mounts
        const fetchData = async () => {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                }
            };

            try {
                const response = await fetch(`${baseURL}/pestmanagementrecords/${pestRecordId}`, requestOptions);

                if (response.ok) {
                    const data = await response.json();
                    setPestRecords(data);
                } else {
                    console.error('Error fetching pest record data');
                }
            } catch (error) {
                console.error('Error fetching pest record data:', error);
            }
        };

        fetchData();
    }, [pestRecordId, navigate, user]);



    return (<>


        {/* Page wrapper start */}
        <div className="page-wrapper">

            {/* Sidebar wrapper start */}
            <SideBarWrapper />
            {/* Sidebar wrapper end */}

            {/* Page content start  */}
            <div className="page-content">

                {/* Header start */}
                <Navbar />
                {/* Header end */}

                {/* Page header start */}
                <div className="page-header">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item">{pestRecords && pestRecords && pestRecords.code}</li>
                        <li className="breadcrumb-item">
                            <Link to={`/pestmanagementrecords/crop/${pestRecords && pestRecords && pestRecords.cropId}`} >Pest Management Records</Link>
                        </li>
                        <li className="breadcrumb-item active">Edit</li>
                    </ol>
                    <ul className="app-actions">
                    </ul>
                </div>
                {/* Page header end */}

                {/* Main container start */}
                <div className="main-container">
                    <PestForm crop={pestRecords && pestRecords.crop} pestRecords={pestRecords && pestRecords}/>
                </div>
                {/* Main container end */}

            </div>
            {/* Page content end */}
            <Footer/>

        </div>
        {/* Page wrapper end */}
    </>);
}

export default EditPestRecord;